/* eslint-disable quotes */
/* eslint-disable semi */
import { storeMutations } from '@store/mutations.constants';
import licenseState from './state';

export const state = licenseState;
const mutations = {
  [storeMutations.vsmMetricList]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.vsmList = res.data;
    }
  },
  [storeMutations.setAddVsmMetric]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.vsmList = res.data;
    }
  },
  [storeMutations.setVsmsMutation]: (state, res) => {
    if (res.status === 200) {
      // state.user = res.data.user;
      state.vsms = res.data;
    }
  },
};
export default {...mutations };